module.exports = __webpack_public_path__ + "img/menu_ladies_hifu.078e169f.png";